<div class="container p-4 h-100 d-flex flex-column">
  <div class="d-flex justify-content-between align-items-start w-100 mb-2">
    <div class="back-btn-container">
      <app-back-button></app-back-button>
    </div>
    <app-bhashini-language-translation></app-bhashini-language-translation>
  </div>
  <div class="d-flex justify-content-start flex-column align-items-center">
    <img
      fetchpriority="high"
      width="136"
      height="90"
      src="images/ai-kosh-logo.svg"
      alt="AIKosh"
      title="AIKosh"
      class="cursor-pointer"
      (click)="redirectToHome()"
    />
    <h1 class="text-3xl mt-2 fw-600">Welcome to the Platform</h1>

    <div class="p-3 text-center">
      <h1 class="text-2xl fw-600">Step 1 : Select Your Role</h1>
      <p class="text-base text__gray mb-0">
        Choose the role that best matches what you want to do on the platform
      </p>
    </div>
  </div>

  <!-- Role Cards -->

  <div class="d-flex flex-column justify-content-between flex-grow-1">
    <ng-container *ngTemplateOutlet="roleCards"></ng-container>

    <!-- Already have account -->
    <div class="text-center my-4" (click)="redirectToLogin()">
      <span>
        Already have an account?
        <span class="text-decoration-underline cursor-pointer">Login</span>
      </span>
    </div>
  </div>
</div>

<ng-template #roleCards>
  <div class="role-cards-grid">
    <!-- Explorer Role Card -->
    <ng-container
      *ngTemplateOutlet="roleCard; context: explorerRole"
    ></ng-container>

    <!-- Contributor Role Card -->
    <ng-container
      *ngTemplateOutlet="roleCard; context: contributorRole"
    ></ng-container>

    <!-- Organization Admin Role Card -->
    <ng-container
      *ngTemplateOutlet="roleCard; context: organizationAdminRole"
    ></ng-container>
  </div>
</ng-template>

<!-- Role Card Template -->
<ng-template
  #roleCard
  let-icon="icon"
  let-title="title"
  let-description="description"
  let-permissions="permissions"
  let-recommendation="recommendation"
  let-note="note"
  let-buttonText="buttonText"
  let-role="role"
>
  <div class="p-4 card-container role-card">
    <!-- Row 1: Icon + Title + Description -->
    <div>
      <img
        class="flex-shrink-0 mb-3"
        fetchpriority="high"
        width="68"
        height="68"
        [src]="icon"
        alt="Individual"
      />
      <div class="text-base fw-700 mb-1">{{ title }}</div>
      <div class="text-base">{{ description }}</div>
    </div>

    <!-- Row 2: Key Permissions -->
    <div>
      <div class="text-base fw-400 mb-2">Key Permissions :</div>
      <div
        *ngFor="let permission of permissions"
        class="d-flex align-items-start gap-2 mb-2"
      >
        <img
          src="images/success.svg"
          alt="Success"
          width="15"
          height="15"
          class="mt-1"
        />
        <span class="text-base">{{ permission }}</span>
      </div>
    </div>

    <!-- Row 3: Recommendation Box -->
    <div class="bg-primary-bg p-3 rounded-3 w-100 align-self-lg-end">
      <span class="text-sm">{{ recommendation }}</span>
      @if (note) {
        <br />
        <span class="text-sm fw-600 mt-1">
          {{ note }}
        </span>
      }
    </div>

    <!-- Row 4: Select Button -->
    <button
      class="btn btn-secondary w-100 align-self-end"
      (click)="moveToStep2(role)"
    >
      <span class="text-base">{{ buttonText }}</span>
      <span><img src="images/arrow-right-gray.svg" class="ms-2" alt="" /></span>
    </button>
  </div>
</ng-template>
